export default {
    container: {
        height: "100%",
        "& .MuiDataGrid-root": {
            border: "none",
            height: "77vh"
        }
    },
    createTab: {
        marginRight: 0,
        borderRadius: 32
    },
    dummyTab: {
        padding: 0,
        minWidth: 0
    },
    tabHeader: { px: 2, py: 4 },

};
